import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Box, MenuItem, Select, Stack, Typography } from '@mui/material';

import useEqualSizeSxProps from 'src/components/utils/useEqualSizeSxProps';

type RequiredAdvanceNoticeProps = {
  value?: number;
  onChange: (value: number) => void;
};

const RequiredAdvanceNotice = ({ value, onChange }: RequiredAdvanceNoticeProps) => {
  const { t } = useTranslation();
  const sxProps = useEqualSizeSxProps();
  const advanceNoticeOptions: { id: number; value: string }[] = [
    { id: 0, value: t('hiring-dashboard-common:common.none') },
    { id: 24, value: t('hiring-dashboard-schedule:schedule.selfScheduleOptions.advanceNoticeHours', { count: 24 }) },
    { id: 48, value: t('hiring-dashboard-schedule:schedule.selfScheduleOptions.advanceNoticeHours', { count: 48 }) },
  ];

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={sxProps.equalSizeChild}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      spacing={2}
    >
      <Typography>{t('hiring-dashboard-schedule:schedule.selfScheduleOptions.advancedNotice')}</Typography>
      <Box>
        <Select
          fullWidth
          data-testid="self-schedule-options-advance-notice-select"
          onChange={(val) => onChange(val.target.value as number)}
          value={advanceNoticeOptions.find((option) => option.id === value)?.id ?? advanceNoticeOptions[1].id}
        >
          {advanceNoticeOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.value}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Stack>
  );
};

export default RequiredAdvanceNotice;
